import { Loader } from './loader'

const Loading = Loader

export default Loading

export { Loading }
